import {createActions} from 'reduxsauce';

export const { Types: MotdePasseTypes, Creators: MotdePasseActionCreators} = createActions ({
    motdePasseResetPasswordStart: ['password', 'resetKey'],
    motdePasseResetPasswordSuccess: ['userData'],
    motdePasseResetPasswordFailure: ['error'],

});